import { useEffect } from "react";

import { ScreenPath } from "@/constants/Navigation";
import { Redirect, usePathname } from "@/crossPlatform/expo-router";
import useAuth from "@/hooks/useAuth";
import useAppMonitor from "@/services/AppMonitor";

const RouteFallback = () => {
  const pathname = usePathname();
  const { captureMessage } = useAppMonitor();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    captureMessage("Route fallback triggered", {
      context: {
        pathname,
      },
    });
    // only the pathname at mount is the trigger of the fallback;
    // if pathname happens to re-render before <Redirect /> completes, we don't want to re-fire this
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const destination = isAuthenticated
    ? ScreenPath.PostLoginRouting
    : ScreenPath.Login;

  return <Redirect href={destination} />;
};

// eslint-disable-next-line import-x/no-unused-modules
export default RouteFallback;
